import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import shouldForwardProp from "@styled-system/should-forward-prop";
import {
  compose,
  height,
  HeightProps,
  padding,
  PaddingProps,
  width,
  WidthProps,
} from "styled-system";

const Item = styled("li", {
  shouldForwardProp,
})<HeightProps & PaddingProps>(
  ({ theme }) =>
    css({
      padding: `${theme.space.m}`,
      "& + &": {
        borderTop: theme.borders.default,
      },
    }),
  () => compose(height, padding),
);

const Root = styled("ul", {
  shouldForwardProp,
})<WidthProps & { selectable?: boolean }>(
  ({ theme, selectable }) =>
    css({
      borderBottom: theme.borders.default,
      ...(selectable && {
        [`& > ${Item}`]: {
          transitionDuration: theme.transitions.default,
          "&:hover": {
            background: theme.colors.background.bg,
            cursor: "pointer",
          },
        },
      }),
    }),
  () => compose(width),
);

export const List = Object.assign(Root, { Item });
